module.exports = function() {
  return new Worker(__webpack_public_path__ + "996966806ee0573d6248.worker.js");
};